import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/platform";
// 平台列表
const platformApi = {
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  },
  // 获得平台信息
  getInfo(id) {
    return request({
      url: `${baseUrl}/get`,
      method: "GET",
      params: { id }
    });
  }
};
export default platformApi;
